import { Loader2 } from 'lucide-react'

export default function ProcessingOverlay({ message }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-[2px]">
      <div className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 shadow-lift">
        <Loader2 className="h-5 w-5 animate-spin-slow text-brand-600" />
        <p className="text-sm font-medium text-slate-700">
          {message || 'Processing...'}
        </p>
      </div>
    </div>
  )
}
